import React, { useState } from 'react';
import ProductPage from './ProductPage';  // Assuming you have a ProductPage component
import DashboardPage from './DashboardPage'; // Assuming you have a DashboardPage component
import UsersPage from './UserPage'; // Assuming you have a UsersPage component
import TransactionsPage from './TransactionPage';
import EditWebsite from './EditWebsite';//
import '../styles/AdminPage.css';  // The main stylesheet

const AdminPage = () => {
  const [activePage, setActivePage] = useState('dashboard'); // Initial page is 'dashboard'
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  return (
    <div className="admin-page-container">
      {/* Sidebar */}
      <div className="sidebar">
        {/* Logo */}
        <div className="logo">
          <img src="logo-net.png" alt="Logo" /> {/* Replace with your logo */}
        </div>

        {/* Navigation Links */}
        <ul>
          <li>
            <button onClick={() => setActivePage('dashboard')}>Početna Stranica</button>
          </li>
          <li>
            <button onClick={() => setActivePage('product')}>Proizvodi</button>
          </li>
          <li>
            <button onClick={() => setActivePage('user')}>Korisnici</button>
          </li>
          <li>
            <button onClick={() => setActivePage('transactions')}>Transakcije</button>
          </li>
        </ul>
      </div>

      {/* Content Area */}
      <div className="content-area">
        {activePage === 'dashboard' && <DashboardPage />}
        {activePage === 'product' && <ProductPage />}
        {activePage === 'user' && <UsersPage />}
        {activePage === 'transactions' && <TransactionsPage />}
      </div>
    </div>
  );
};

export default AdminPage;
